import HightLight from './hightLight/HightLight'
import PanelContainer from './panelContainer'

const Body = () => {
  return (
    <>
      <HightLight />
      <PanelContainer />
    </>
  )
}

export default Body
